import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

function money(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

// Order history tab. RLS scopes rows to auth.uid(), so no user filter needed.
export default function OrdersTab() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('orders')
      .select('id, order_token, total_cents, payment_status, fulfillment_status, created_at')
      .order('created_at', { ascending: false })
      .then(({ data }) => { setOrders(data || []); setLoading(false); });
  }, []);

  if (loading) return <p style={{ color: 'var(--text-muted)' }}>Loading…</p>;

  if (orders.length === 0) {
    return (
      <div>
        <p style={{ color: 'var(--text-muted)', marginBottom: 14 }}>No orders yet.</p>
        <Link to="/shop" className="sv-btn" style={{ display: 'inline-flex' }}>Browse the shop</Link>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {orders.map((o) => (
        <Link
          key={o.id}
          to={`/order/${o.order_token}`}
          className="sv-card"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px' }}
        >
          <div>
            <div style={{ fontWeight: 700 }}>#{o.id.slice(0, 8).toUpperCase()}</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
              {new Date(o.created_at).toLocaleDateString()} · {o.payment_status}
            </div>
          </div>
          <div style={{ fontWeight: 800 }}>{money(o.total_cents)}</div>
        </Link>
      ))}
    </div>
  );
}
